import React, { useRef, useState } from 'react';
import {
  DatePicker, DatePickerProps
} from 'antd';
import type { Moment } from 'moment';
import {PrefixIconWrapper, Wrapper} from './styles';
import { ReactComponent as CalendarIcon } from '../../../assets/images/calendar-grey.svg';

type Props = {
  onChange?: (dateString: Moment | null) => void
} & DatePickerProps

function StyledDatePicker({
  size, placeholder, value, onChange, disabledDate,
}: Props) {
  const popoverContainerRef = useRef(null);

  const [focus, setFocus] = useState(false);
  const [selectedValue, setSelectedValue] = useState<Moment | null>();

  const hasValue = focus || (selectedValue) || value;
  const labelClass = hasValue ? 'label as-label' : 'label as-placeholder';

  const handleDateChange: DatePickerProps['onChange'] = (date) => {
    setSelectedValue(date);
    if (onChange) onChange(date);
  };

  const getContainer = () => popoverContainerRef.current as unknown as HTMLElement;

  return (
    <Wrapper
      ref={popoverContainerRef}
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      <DatePicker
        size={size}
        placeholder=""
        suffixIcon={null}
        disabledDate={disabledDate}
        value={value}
        onChange={handleDateChange}
        inputReadOnly
        getPopupContainer={getContainer}
      />
      <span className={labelClass}>
        {hasValue ? placeholder : placeholder}
      </span>

      <PrefixIconWrapper>
        <CalendarIcon />
      </PrefixIconWrapper>
    </Wrapper>
  );
}

StyledDatePicker.defaultProps = {
  placeholder: '',
  size: 'large',
  value: undefined,
  disabledDate: undefined,
  onChange: undefined,
};
export default StyledDatePicker;
